module.exports = __webpack_public_path__ + "img/56-r.579d81e7.png";